import { useTranslation } from '@frontend/i18n';
import { PopoverMenu, PopoverMenuItem, Text } from '@frontend/design-system';
import { ConversationTypeFilter } from '../../../types';
import { FilterItemPopoverRadioField } from '../filter-item-popover-radio';
import { GetItemPropsFn, GetMenuPropsFn } from '../types';

type ConversationTypeFilterPopoverMenuProps = {
  getMenuProps: GetMenuPropsFn;
  getItemProps: GetItemPropsFn;
  onSelect: (conversationType: ConversationTypeFilter) => void;
  selectedConversationType: ConversationTypeFilter | '';
};

const availableConversationTypes = [ConversationTypeFilter.INDIVIDUAL, ConversationTypeFilter.GROUP];

const styles = {
  menu: {
    minWidth: 180,
  },
  menuItem: {
    width: '100%',
    cursor: 'pointer',
    padding: 'var(--fabric-space-padding-xxs) var(--fabric-space-padding-xs)',
    '*': {
      cursor: 'pointer',
    },
  },
} as const;

export const ConversationTypeFilterPopoverMenu = ({
  getMenuProps,
  getItemProps,
  onSelect,
  selectedConversationType,
}: ConversationTypeFilterPopoverMenuProps): ReturnType<typeof PopoverMenu> => {
  const { t } = useTranslation('inbox');

  const conversationTypeLabels: Record<ConversationTypeFilter, string> = {
    [ConversationTypeFilter.INDIVIDUAL]: t('Individual'),
    [ConversationTypeFilter.GROUP]: t('Group'),
  };

  const handleSelectOption = (conversationType: ConversationTypeFilter) => {
    onSelect(conversationType);
  };

  return (
    <PopoverMenu {...getMenuProps()} css={styles.menu}>
      {availableConversationTypes.map((conversationType, index) => (
        <PopoverMenuItem
          key={conversationType}
          {...getItemProps({
            index,
            disableCloseOnSelect: true,
            onClickCapture: (e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSelectOption(conversationType);
            },
          })}
          css={styles.menuItem}
        >
          <FilterItemPopoverRadioField
            label=''
            options={[conversationType]}
            value={selectedConversationType === conversationType ? conversationType : undefined}
            displayValue={<Text>{conversationTypeLabels[conversationType]}</Text>}
          />
        </PopoverMenuItem>
      ))}
    </PopoverMenu>
  );
};
